module.exports = __webpack_public_path__ + "img/슈퍼싱글침대.11a2cd59.png";